import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
